import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { theme } from "@repo-sapiens/theme";

type HeaderProps = {
  bg?: string;
};
export const HeaderBase = styled.header<HeaderProps>`
  height: 200px;
  width: 100%;
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 16px;
  padding: 20px 20px;
  @media (max-height: 700px) {
    max-height: 123px;
  }
`;

export const DashobardContainer = css`
  width: 100%;
  max-width: 688px;
  margin: auto;
  padding: 0px 0px;
`;

export const PodcastPlayStyle = css`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${theme.colors.accent.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 38px;
    height: 38px;
  }
`;

export const PodcastPlayIconStyle = {
  width: "28px",
  height: "28px",
};

export const UpcomingCardStyle = css`
  margin-bottom: 28px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const UpcomingCardRightStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  width: 30%;
`;

export const LocationContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;
export const LocationIconStyle = {
  width: "12px",
  height: "12px",
  marginRight: "4px",
};

export const MeetingLinkIconStyle = {
  width: "8px",
  height: "10px",
  marginLeft: "4px",
};

export const ViewMeetingContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const MeetingItemStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 16px 0px;
  width: 100%;
`;

export const MeetingItemRightStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 30%;
`;

export const DotIconStyle = {
  width: "4px",
  height: "4px",
  marginRight: "4px",
  marginLeft: "4px",
};

export const MeetingListCardStyle = css`
  margin-bottom: 28px;
  display: flex;
  flex-direction: column;
`;
export const MeetingInviteContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border: 1px solid white;
  border-radius: 50px;
  overflow: hidden;
`;
export const MeetingInviteSentStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const AdHocBotInviteStyle = css`
  width: 100%;
  position: relative;
`;
export const AdHocBotInviteDisabledStyle = css`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 8px;
  background: ${theme.colors.background.primary};
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    backdrop-filter: blur(10px); /* Blurs the background behind */
    background: #161617;
    opacity: 0.5;
    z-index: -1;
    border-radius: 8px; /* Optional rounded corners */
  }
`;

export const ManageSubscriptionButtonStyle = css`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  height: 40px;
  width: fit-content;
  max-width: 150px;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.dark};
  position: relative;
  overflow: hidden;
  background-color: white;
  font-size: 16px;
  padding: 0px 16px;
  &:disabled {
    cursor: not-allowed;
    background: transparent;
    border: 1px solid white;
    color: ${theme.colors.text["text/main"]};
  }
`;

export const GoToBillingButtonStyle = css`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  height: 40px;
  width: fit-content;
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.dark};
  position: relative;
  overflow: hidden;
  background-color: white;
  font-size: 16px;
  padding: 0px 24px;
  &:disabled {
    cursor: not-allowed;
    background: transparent;
    border: 1px solid white;
    color: ${theme.colors.text["text/main"]};
  }
`;
